import React from "react";
import "./home.scss";

const MyShit = () => {
  const stars = [];

  for (let i = 0; i < 100; i++) {
    stars.push(
      <div className="circle-container" key={i}>
        <div className="circle"></div>
      </div>
    );
  }

  return (
    <div className="2xl:p-40 md:p-12 pt-20 max-h-full">
      <div className="background">{stars}</div>
      <h1 className="md:text-5xl text-3xl font-Fira pt-10 px-5 font-bold">
        Anargyros Stylidis
      </h1>
      <p className="md:text-3xl text-2xl text-yellow-200 sm:ml-2 px-10 pt-12 pb-14 font-Fira">
        Full Stack Developer.
      </p>
      <p className="text-xl text-white sm:ml-2 px-10 italic">
        I like building single-page applications using React, Tailwind and{" "}
        NodeJS.
      </p>
      <p className=" text-xl text-white sm:ml-2 py-1 px-10 italic">
        I've got great communication skills and perform better in a team.
      </p>
      <p className=" text-xl text-white sm:ml-2 py-2 px-10 ">
        I am <span className="font-bold text-yellow-200">available</span> for
        hire and open to any ideas of cooperation.
      </p>
    </div>
  );
};

export default MyShit;
